// @flow

export const setUserLocation = (position: Position) => {
  return {
    type: 'USER_LOCATION/SET',
    payload: position,
  };
};
